export const euro = (n, currency = "EUR") =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: currency || "EUR" }).format(
    Number.isFinite(n) ? n : 0
  );

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  return d.toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" });
};

export const daysLeft = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d)) return null;
  const now = new Date();
  return Math.ceil((d.setHours(23, 59, 59) - now) / 86400000);
};

export const WORK_UNIT_LABELS = {
  giorni: { one: "giorno lavorativo", many: "giorni lavorativi" },
  ore: { one: "ora", many: "ore" },
  settimane: { one: "settimana", many: "settimane" },
};

export const workLabel = (n, unit = "giorni") => {
  const num = Number(n) || 0;
  const u = WORK_UNIT_LABELS[unit] || WORK_UNIT_LABELS.giorni;
  return `${num} ${num === 1 ? u.one : u.many}`;
};

export const timeAgo = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return "pochi secondi fa";
  const m = Math.floor(s / 60);
  if (m < 60) return `${m} min fa`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h} ${h === 1 ? "ora" : "ore"} fa`;
  const g = Math.floor(h / 24);
  if (g < 30) return `${g} ${g === 1 ? "giorno" : "giorni"} fa`;
  return fmtDate(iso);
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  return d.toLocaleString("it-IT", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

export const leadTemp = (q) => {
  const v = q.totale_visite || 0;
  const interacted = !!q.has_interactions && q.status !== "accettato" && q.status !== "rifiutato";
  if (v >= 3 || interacted) return { key: "caldo", label: "Caldo 🔥", cls: "bg-orange-50 text-orange-700 border-orange-200" };
  if (v >= 1) return { key: "tiepido", label: "Tiepido", cls: "bg-amber-50 text-amber-700 border-amber-200" };
  return { key: "freddo", label: "Freddo", cls: "bg-slate-100 text-slate-500 border-slate-200" };
};
